


















import NavSecondary from "@/components/NavSecondary.vue";
import url from "@/mixins/analytics/url";
import { Component, Mixins } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({ components: { NavSecondary } })
export default class AppNavSecondary extends Mixins(url) {
  @Getter("provider") provider!: string;

  get docsURL() {
    return this.provider === "heroku" ? this.url.herokuDocs : this.url.docs;
  }
}
